import React, { useState } from 'react';

const Header = () => {
  const [hoveredLink, setHoveredLink] = useState(null); // Zustand, um den aktuell gehoverten Link zu speichern

  const handleMouseEnter = (link) => {
    setHoveredLink(link); // Speichere den Link, der gehovt wird
  };

  const handleMouseLeave = () => {
    setHoveredLink(null); // Entferne den Hover-Zustand
  };

  return (
    <header style={styles.header}>
      <div style={styles.logoContainer}>
        <img src={require('../assets/images/logotrkl.png')} alt="Logo" style={styles.logo} />
      </div>
      <nav style={styles.nav}>
        {['Startseite', 'Meine Mission', 'Kontakt', 'Erfolgsstory', 'Angebot'].map((link) => (
          <a
            key={link}
            href={`#${link.toLowerCase()}`}
            style={{
              ...styles.link,
              color: hoveredLink === link ? '#fff' : 'black', // Ändere die Farbe beim Hover
            }}
            onMouseEnter={() => handleMouseEnter(link)}
            onMouseLeave={handleMouseLeave}
          >
            {link}
          </a>
        ))}
      </nav>
    </header>
  );
};

const styles = {
  header: {
    position: 'fixed',
    top: 0,
    width: '100%',
    backgroundColor: '#f4a7b9',
    padding: '10px 20px',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
  },
  logoContainer: {
    marginRight: '20px',
  },
  logo: {
    height: '200px',
    width: 'auto',
  },
  nav: {
    display: 'flex',
    justifyContent: 'space-around',
    flex: 1,
  },
  link: {
    color: 'black',
    textDecoration: 'none',
    fontSize: '1.8em',
    transition: 'color 0.3s ease', // Animation für den Farbwechsel
  },
};

export default Header;
